var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.019,
    height: 55.813,
    viewBox: "0 0 38.019 55.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-electricity-1713993",
    transform: "translate(-159.264 0.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3687",
    "data-name": "Path 3687",
    d: "M181.1,21.021h15.368a.809.809,0,0,1,.691,1.23L176.942,55.413a.809.809,0,0,1-1.5-.421V34.771H160.074a.809.809,0,0,1-.691-1.23L179.605.378A.809.809,0,0,1,181.1.8Zm-.809,1.618a.809.809,0,0,1-.809-.809V3.68L161.515,33.154h14.736a.809.809,0,0,1,.809.809V52.113l17.972-29.474Z",
    transform: "translate(0 0)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricity);
export default __webpack_public_path__ + "static/media/electricity.6d398ee393e3e1e26e4e0b6e54e4e21a.svg";
export { ForwardRef as ReactComponent };